/**
 * UI específica de atendente / painel (ponto, KPIs, metas).
 * PT / EN / ES — merged em messages.js
 */

const ptBR = {
  'nav.liveClients': 'Clientes conectados',
  'sidebar.pin': 'Fixar em Favoritos',
  'sidebar.unpin': 'Desafixar',

  'dash.att.welcomeAria': 'Boas-vindas',
  'dash.att.panelFallback': 'Seu painel',
  'dash.att.roleFallback': 'Atendente',
  'dash.att.helloMorning': 'Bom dia',
  'dash.att.helloAfternoon': 'Boa tarde',
  'dash.att.helloEvening': 'Boa noite',
  'dash.att.welcomeSub':
    'Acompanhe comissões, metas e resultados do seu atendimento em um só lugar. Use {quickTest} e {newClient} no topo para as ações rápidas.',
  'dash.att.commissionMonth': 'Comissão do mês',
  'dash.att.yourRate': 'Taxas · {pct}',
  'dash.att.activeClients': 'Clientes ativos',
  'dash.att.createdByYou': '{n} criados por você',
  'dash.att.visibleOfficeClients': '{n} clientes visíveis do Office',
  'dash.att.testsGenerated': 'Testes gerados',
  'dash.att.newClientsMonth': '{n} clientes novos no mês',
  'dash.att.resellers': 'Revendas',
  'dash.att.resellersMonth': '{n} cadastradas no mês',
  'dash.kpiClients30d': 'Clientes · 30 dias',
  'dash.kpiCredits30d': 'Créditos · 30 dias',
  'dash.kpiPaidRenewals': '{n} renovações pagas',
  'dash.kpiCreditsResellers': '{n} créditos · revendas',
  'dash.kpiYesterdayClients': 'Ontem {value} · clientes',
  'dash.chartBaseCum': 'Base acumulada',
  'dash.chartNewDay': 'Novos no dia',
  'dash.generateTest': 'Gerar teste',

  'att.goalMeta': 'Meta: {n}',
  'att.goalWaiting': 'Aguardando meta do administrador',
  'att.commissionPeriod': 'Comissão · {period}',
  'att.thisMonth': 'este mês',
  'att.rateBadge': 'Taxa {pct}',
  'att.lifetime': 'Acumulado na conta · {value}',
  'att.refresh': 'Atualizar métricas',
  'att.originAria': 'Origem da comissão no mês',
  'att.crmClients': 'Clientes (CRM)',
  'att.paidSales': '{n} vendas pagas',
  'att.creditsIptv': 'Créditos / IPTV',
  'att.goalsTitle': 'Metas do mês',
  'att.goalsSub': 'Progresso automático das metas definidas pela equipe.',
  'att.goalNewClients': 'Novos clientes',
  'att.goalNewResellers': 'Novas revendas',
  'att.goalCommission': 'Comissão',
  'att.activeClients': 'Clientes ativos',
  'att.totalHint': '{n} no total',
  'att.testsGenerated': 'Testes gerados',
  'att.testsHint': 'Somente os seus',
  'att.resellersRegistered': 'Revendas cadastradas',
  'att.thisMonthCount': '{n} este mês',
  'att.crmPaidSales': 'Vendas CRM pagas',
  'att.detailTitle': 'Detalhamento de comissões',
  'att.detailSub': 'CRM e vendas IPTV atribuídas a você neste período.',
  'att.colOrigin': 'Origem',
  'att.colMonth': 'Este mês',
  'att.colTotal': 'Total',
  'att.salesCount': '{n} vendas',

  'acb.aria': 'Status de atendimento',
  'acb.statusAria': 'Disponibilidade para atendimento',
  'acb.kicker': 'Status de atendimento',
  'acb.offDuty': 'Turno encerrado',
  'acb.elapsed': 'Atualizado há {elapsed}',
  'acb.pickStatus': 'Informe quando estiver pronto para atender',
  'acb.notePause': 'Nota privada (opcional)',
  'acb.noteOptional': 'Nota privada para a gestão (opcional)',
  'acb.noteAria': 'Nota privada do status',
  'acb.notePrivacy': 'A nota é opcional e visível somente para a gestão.',
  'acb.guidance': 'Organiza a fila de atendimento. Pausas comuns não exigem justificativa.',
  'acb.more': 'Ausência ou observação',
  'acb.uploadSick': 'Anexar justificativa de ausência',
  'acb.docOk': 'Documento enviado — aguardando confirmação do administrador',
  'acb.docFail': 'Falha no upload',
  'acb.docNote': 'Atestado / ausência',
  'acb.statusToast': 'Status: {label}',
  'acb.errNetwork': 'Sem resposta do servidor (rede/CORS). Tente F5.',
  'acb.errSession': 'Sessão expirada — entre novamente.',
  'acb.errForbidden': 'Sem permissão para alterar a disponibilidade.',
  'acb.errHttp': 'Falha ao atualizar o status (HTTP {code})',
  'acb.errGeneric': 'Falha ao atualizar o status',
  'acb.roleFallback': 'Atendente',
  'acb.status.available': 'Atendendo',
  'acb.status.lunch': 'Refeição',
  'acb.status.dinner': 'Janta',
  'acb.status.bathroom': 'Banheiro',
  'acb.status.break': 'Pausa',
  'acb.status.unavailable': 'Indisponível',
  'acb.status.off': 'Encerrar turno',
  'acb.status.sick': 'Ausência justificada',
};

const en = {
  'nav.liveClients': 'Connected clients',
  'sidebar.pin': 'Pin to Favorites',
  'sidebar.unpin': 'Unpin',

  'dash.att.welcomeAria': 'Welcome',
  'dash.att.panelFallback': 'Your dashboard',
  'dash.att.roleFallback': 'Agent',
  'dash.att.helloMorning': 'Good morning',
  'dash.att.helloAfternoon': 'Good afternoon',
  'dash.att.helloEvening': 'Good evening',
  'dash.att.welcomeSub':
    'Track commissions, goals and your support results in one place. Use {quickTest} and {newClient} in the header for quick actions.',
  'dash.att.commissionMonth': 'Month commission',
  'dash.att.yourRate': 'Rates · {pct}',
  'dash.att.activeClients': 'Active clients',
  'dash.att.createdByYou': '{n} created by you',
  'dash.att.visibleOfficeClients': '{n} visible Office clients',
  'dash.att.testsGenerated': 'Trials generated',
  'dash.att.newClientsMonth': '{n} new clients this month',
  'dash.att.resellers': 'Resellers',
  'dash.att.resellersMonth': '{n} registered this month',
  'dash.kpiClients30d': 'Clients · 30 days',
  'dash.kpiCredits30d': 'Credits · 30 days',
  'dash.kpiPaidRenewals': '{n} paid renewals',
  'dash.kpiCreditsResellers': '{n} credits · resellers',
  'dash.kpiYesterdayClients': 'Yesterday {value} · clients',
  'dash.chartBaseCum': 'Cumulative base',
  'dash.chartNewDay': 'New today',
  'dash.generateTest': 'Generate trial',

  'att.goalMeta': 'Goal: {n}',
  'att.goalWaiting': 'Waiting for an admin goal',
  'att.commissionPeriod': 'Commission · {period}',
  'att.thisMonth': 'this month',
  'att.rateBadge': 'Rate {pct}',
  'att.lifetime': 'Account total · {value}',
  'att.refresh': 'Refresh metrics',
  'att.originAria': 'Commission sources this month',
  'att.crmClients': 'Clients (CRM)',
  'att.paidSales': '{n} paid sales',
  'att.creditsIptv': 'Credits / IPTV',
  'att.goalsTitle': 'Monthly goals',
  'att.goalsSub': 'Automatic progress on goals set by your team.',
  'att.goalNewClients': 'New clients',
  'att.goalNewResellers': 'New resellers',
  'att.goalCommission': 'Commission',
  'att.activeClients': 'Active clients',
  'att.totalHint': '{n} total',
  'att.testsGenerated': 'Trials generated',
  'att.testsHint': 'Yours only',
  'att.resellersRegistered': 'Registered resellers',
  'att.thisMonthCount': '{n} this month',
  'att.crmPaidSales': 'Paid CRM sales',
  'att.detailTitle': 'Commission breakdown',
  'att.detailSub': 'CRM and IPTV sales attributed to you in this period.',
  'att.colOrigin': 'Source',
  'att.colMonth': 'This month',
  'att.colTotal': 'Total',
  'att.salesCount': '{n} sales',

  'acb.aria': 'Time clock',
  'acb.statusAria': 'Attendance status',
  'acb.kicker': 'Clock',
  'acb.offDuty': 'Off duty',
  'acb.elapsed': 'In this status for {elapsed}',
  'acb.pickStatus': 'Select your attendance status',
  'acb.notePause': 'Pause reason (optional)',
  'acb.noteOptional': 'Reason (optional)',
  'acb.noteAria': 'Status reason',
  'acb.notePrivacy': 'The note is optional and visible only to management.',
  'acb.guidance': 'Organizes the service queue. Routine breaks require no justification.',
  'acb.more': 'Absence or note',
  'acb.uploadSick': 'Upload medical note',
  'acb.docOk': 'Document uploaded — waiting for admin confirmation',
  'acb.docFail': 'Upload failed',
  'acb.docNote': 'Medical leave / absence',
  'acb.statusToast': 'Status: {label}',
  'acb.errNetwork': 'No server response (network/CORS). Try F5.',
  'acb.errSession': 'Session expired — sign in again.',
  'acb.errForbidden': 'No permission to clock in.',
  'acb.errHttp': 'Clock failed (HTTP {code})',
  'acb.errGeneric': 'Clock failed',
  'acb.roleFallback': 'Agent',
  'acb.status.available': 'Available',
  'acb.status.lunch': 'Lunch',
  'acb.status.dinner': 'Dinner',
  'acb.status.bathroom': 'Restroom',
  'acb.status.break': 'Break',
  'acb.status.unavailable': 'Unavailable',
  'acb.status.off': 'Clock out',
  'acb.status.sick': 'Sick leave',
};

const es = {
  'nav.liveClients': 'Clientes conectados',
  'sidebar.pin': 'Fijar en Favoritos',
  'sidebar.unpin': 'Desfijar',

  'dash.att.welcomeAria': 'Bienvenida',
  'dash.att.panelFallback': 'Tu panel',
  'dash.att.roleFallback': 'Agente',
  'dash.att.helloMorning': 'Buenos días',
  'dash.att.helloAfternoon': 'Buenas tardes',
  'dash.att.helloEvening': 'Buenas noches',
  'dash.att.welcomeSub':
    'Sigue comisiones, metas y resultados de atención en un solo lugar. Usa {quickTest} y {newClient} arriba para acciones rápidas.',
  'dash.att.commissionMonth': 'Comisión del mes',
  'dash.att.yourRate': 'Tasas · {pct}',
  'dash.att.activeClients': 'Clientes activos',
  'dash.att.createdByYou': '{n} creados por ti',
  'dash.att.visibleOfficeClients': '{n} clientes visibles del Office',
  'dash.att.testsGenerated': 'Pruebas generadas',
  'dash.att.newClientsMonth': '{n} clientes nuevos en el mes',
  'dash.att.resellers': 'Revendedores',
  'dash.att.resellersMonth': '{n} registrados en el mes',
  'dash.kpiClients30d': 'Clientes · 30 días',
  'dash.kpiCredits30d': 'Créditos · 30 días',
  'dash.kpiPaidRenewals': '{n} renovaciones pagadas',
  'dash.kpiCreditsResellers': '{n} créditos · revendedores',
  'dash.kpiYesterdayClients': 'Ayer {value} · clientes',
  'dash.chartBaseCum': 'Base acumulada',
  'dash.chartNewDay': 'Nuevos del día',
  'dash.generateTest': 'Generar prueba',

  'att.goalMeta': 'Meta: {n}',
  'att.goalWaiting': 'Esperando meta del administrador',
  'att.commissionPeriod': 'Comisión · {period}',
  'att.thisMonth': 'este mes',
  'att.rateBadge': 'Tasa {pct}',
  'att.lifetime': 'Acumulado en la cuenta · {value}',
  'att.refresh': 'Actualizar métricas',
  'att.originAria': 'Origen de la comisión del mes',
  'att.crmClients': 'Clientes (CRM)',
  'att.paidSales': '{n} ventas pagadas',
  'att.creditsIptv': 'Créditos / IPTV',
  'att.goalsTitle': 'Metas del mes',
  'att.goalsSub': 'Progreso automático de las metas definidas por el equipo.',
  'att.goalNewClients': 'Nuevos clientes',
  'att.goalNewResellers': 'Nuevos revendedores',
  'att.goalCommission': 'Comisión',
  'att.activeClients': 'Clientes activos',
  'att.totalHint': '{n} en total',
  'att.testsGenerated': 'Pruebas generadas',
  'att.testsHint': 'Solo las tuyas',
  'att.resellersRegistered': 'Revendedores registrados',
  'att.thisMonthCount': '{n} este mes',
  'att.crmPaidSales': 'Ventas CRM pagadas',
  'att.detailTitle': 'Detalle de comisiones',
  'att.detailSub': 'CRM y ventas IPTV atribuidas a ti en este período.',
  'att.colOrigin': 'Origen',
  'att.colMonth': 'Este mes',
  'att.colTotal': 'Total',
  'att.salesCount': '{n} ventas',

  'acb.aria': 'Control de asistencia',
  'acb.statusAria': 'Estado de asistencia',
  'acb.kicker': 'Fichaje',
  'acb.offDuty': 'Fuera de servicio',
  'acb.elapsed': 'En este estado hace {elapsed}',
  'acb.pickStatus': 'Selecciona tu estado de atención',
  'acb.notePause': 'Motivo de la pausa (opcional)',
  'acb.noteOptional': 'Motivo (opcional)',
  'acb.noteAria': 'Motivo del estado',
  'acb.notePrivacy': 'La nota es opcional y solo es visible para la gestión.',
  'acb.guidance': 'Organiza la cola de atención. Las pausas habituales no requieren justificación.',
  'acb.more': 'Ausencia u observación',
  'acb.uploadSick': 'Enviar baja médica',
  'acb.docOk': 'Documento enviado — esperando confirmación del administrador',
  'acb.docFail': 'Error al subir',
  'acb.docNote': 'Baja / ausencia',
  'acb.statusToast': 'Estado: {label}',
  'acb.errNetwork': 'Sin respuesta del servidor (red/CORS). Prueba F5.',
  'acb.errSession': 'Sesión expirada — vuelve a entrar.',
  'acb.errForbidden': 'Sin permiso para fichar.',
  'acb.errHttp': 'Error al fichar (HTTP {code})',
  'acb.errGeneric': 'Error al fichar',
  'acb.roleFallback': 'Agente',
  'acb.status.available': 'Disponible',
  'acb.status.lunch': 'Almuerzo',
  'acb.status.dinner': 'Cena',
  'acb.status.bathroom': 'Baño',
  'acb.status.break': 'Descanso',
  'acb.status.unavailable': 'No disponible',
  'acb.status.off': 'Cerrar',
  'acb.status.sick': 'Baja médica',
};

export const ROLE_UI_MESSAGES = {
  'pt-BR': ptBR,
  en,
  es,
};
